export const meterToFeet = (value: number) => value * 3.28084;
